import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useNavigate, useParams } from 'react-router-dom';
import './BlogPost.css';

const BlogPost = () => {
  const { slug } = useParams();
  const [markdown, setMarkdown] = useState('');
  const [loading, setLoading] = useState(true);
  const [author, setAuthor] = useState('');
  const [date, setDate] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlog = () => {
      fetch(`https://raw.githubusercontent.com/Aditys018/PortfolioBlogs/main/content/blogs/${slug}.md`)
        .then(response => response.text())
        .then(data => {
          // Extract frontmatter
          const frontmatterMatch = data.match(/^---\s*([\s\S]*?)\s*---/);
          let author = '';
          let date = '';
          if (frontmatterMatch) {
            const frontmatter = frontmatterMatch[1];
            const authorMatch = frontmatter.match(/author:\s*["']?(.+?)["']?$/m);
            const dateMatch = frontmatter.match(/date:\s*["']?(.+?)["']?$/m);
            author = authorMatch ? authorMatch[1] : '';
            date = dateMatch ? dateMatch[1] : '';
            setAuthor(author);
            setDate(date);
          }
          // Remove frontmatter and metadata lines from markdown
          const cleaned = data.replace(/^---[\s\S]*?---\s*/g, '')
                              .replace(/^(title|author|date|excerpt|image):.*$/gm, '');
          setMarkdown(cleaned.trim());
          setLoading(false);
        })
        .catch(() => {
          setMarkdown('Blog post not found.');
          setLoading(false);
        });
    };

    fetchBlog();

    const intervalId = setInterval(fetchBlog, 60000);

    return () => clearInterval(intervalId);
  }, [slug]);

  return (
    <div className="blog-post-container">
      <button
        onClick={() => navigate('/blogs-list')}
        className="back-button"
      >
        ← Back
      </button>
      
      <div className="blog-post">
        <div className="blog-post-header">
          <h1>{slug.replace(/-/g, ' ')}</h1>
          <div className="blog-post-meta">
            <span>Author: {author || "Unknown"}</span>
            <span>Published: {date || "Unknown"}</span>
          </div>
          <hr className="blog-post-divider" />
        </div>

        <div className="blog-post-content">
          {loading ? (
            <p>Loading post...</p>
          ) : (
            <ReactMarkdown>{markdown}</ReactMarkdown>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogPost;